import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import { ApiRequestError, getUserInput } from '../../../services/api';
import { Detaljeringssteg } from '../../../types/registration/userInput';
import { queryKeys } from '../../../utils/react-query';
import { updateRegistration as updateRegistrationAction } from '../../../store/registration/actions';

export const useGetUserInput = (
  registrationId: string | undefined,
  updateSteps: (detailingSteps?: Detaljeringssteg | undefined) => void
) => {
  const dispatch = useDispatch();
  const { data, isLoading, isError, error } = useQuery<
    Awaited<ReturnType<typeof getUserInput>>,
    ApiRequestError
  >(
    [queryKeys.userInput, registrationId],
    () => getUserInput(registrationId),
    {
      onSuccess(userInput) {
        dispatch(updateRegistrationAction({ userInput }));
        updateSteps(userInput?.detaljeringssteg);
      },
      enabled: !!registrationId
    }
  );

  return { response: data, isLoading, userInputError: isError && !data ? error : null };
};

export const useGetUserInputReadOnly = (registrationId: string | undefined) => {
  const { data, isLoading, isError, error } = useQuery<
    Awaited<ReturnType<typeof getUserInput>>,
    ApiRequestError
  >(
    [queryKeys.userInput, registrationId],
    () => getUserInput(registrationId),
    {
      enabled: !!registrationId
    }
  );

  return { userInput: data, userInputLoading: isLoading, userInputError: isError && !data ? error : null };
};
